import { useQuery } from '@tanstack/react-query';

import { getProductImageAssets } from '../api/product-image-assets';

export const USE_PRODUCT_IMAGE_ASSETS_KEY = 'product-image-assets';

export function useProductImageAsset(productId: number, draftId?: number) {
  return useQuery({
    queryKey: [USE_PRODUCT_IMAGE_ASSETS_KEY, productId, draftId],
    queryFn: () => getProductImageAssets(productId, draftId),
    // A draft on a product that does not exist yet still has images, so a draft id alone is enough
    // to read them; without this the editor could not render what it just saved.
    enabled: productId > 0 || (draftId ?? 0) > 0,
    staleTime: 1000 * 60 * 5,
  });
}
